// ============================================================
// FONADHOO CRM v3.3 - CONSTANTS & CONFIGURATION
// All enums, roles, categories, and static data
// ============================================================

// ══════════════════════════════════════════════════════════
// FAMILY TREE - 3 SIMPLE ROLES
// ══════════════════════════════════════════════════════════

export const FAMILY_ROLES = [
  'Parent',
  'Family Member'
];

// Generation mapping for tree layout
// New simplified roles + backward compatibility with old 56 roles
export const ROLE_GENERATION = {
  // NEW SIMPLIFIED ROLES (3)
  'Grandparent': 1,
  'Parent': 2,
  'Family Member': 3,
  
  // BACKWARD COMPATIBILITY - OLD 56 ROLES (keep existing data working)
  // Generation 0 (Great-great-grandparents)
  'Great-Grandfather': 0,
  'Great-Grandmother': 0,
  
  // Generation 1 (Great-grandparents & Grandparents)
  'Great-Grandfather (Father\'s Father\'s Father)': 0,
  'Great-Grandmother (Father\'s Father\'s Mother)': 0,
  'Great-Grandfather (Father\'s Mother\'s Father)': 0,
  'Great-Grandmother (Father\'s Mother\'s Mother)': 0,
  'Great-Grandfather (Mother\'s Father\'s Father)': 0,
  'Great-Grandmother (Mother\'s Father\'s Mother)': 0,
  'Great-Grandfather (Mother\'s Mother\'s Father)': 0,
  'Great-Grandmother (Mother\'s Mother\'s Mother)': 0,
  'Grandfather': 1,
  'Grandmother': 1,
  'Paternal Grandfather (Father\'s Father)': 1,
  'Paternal Grandmother (Father\'s Mother)': 1,
  'Maternal Grandfather (Mother\'s Father)': 1,
  'Maternal Grandmother (Mother\'s Mother)': 1,
  
  // Generation 2 (Parents, Uncles, Aunts, In-laws)
  'Father': 2,
  'Mother': 2,
  'Uncle': 2,
  'Aunt': 2,
  'Uncle (Father\'s Brother)': 2,
  'Aunt (Father\'s Sister)': 2,
  'Uncle (Mother\'s Brother)': 2,
  'Aunt (Mother\'s Sister)': 2,
  'Uncle\'s Wife (Father\'s Side)': 2,
  'Aunt\'s Husband (Father\'s Side)': 2,
  'Uncle\'s Wife (Mother\'s Side)': 2,
  'Aunt\'s Husband (Mother\'s Side)': 2,
  'Father-in-Law': 2,
  'Mother-in-Law': 2,
  
  // Generation 3 (You, Siblings, Cousins, Spouses)
  'Me': 3,
  'Brother': 3,
  'Sister': 3,
  'Half-Brother (Father\'s Side)': 3,
  'Half-Sister (Father\'s Side)': 3,
  'Half-Brother (Mother\'s Side)': 3,
  'Half-Sister (Mother\'s Side)': 3,
  'Cousin': 3,
  'Cousin (Father\'s Side)': 3,
  'Cousin (Mother\'s Side)': 3,
  'Husband': 3,
  'Wife': 3,
  'Brother\'s Wife': 3,
  'Sister\'s Husband': 3,
  'Cousin\'s Husband': 3,
  'Cousin\'s Wife': 3,
  'Cousin\'s Husband (Father\'s Side)': 3,
  'Cousin\'s Wife (Father\'s Side)': 3,
  'Cousin\'s Husband (Mother\'s Side)': 3,
  'Cousin\'s Wife (Mother\'s Side)': 3,
  'Brother-in-Law (Spouse\'s Brother)': 3,
  'Sister-in-Law (Spouse\'s Sister)': 3,
  'Brother-in-Law (Sibling\'s Husband)': 3,
  'Sister-in-Law (Sibling\'s Wife)': 3,
  'Other': 3,
  
  // Generation 4 (Children, Nieces, Nephews)
  'Son': 4,
  'Daughter': 4,
  'Son-in-Law': 4,
  'Daughter-in-Law': 4,
  'Nephew': 4,
  'Niece': 4,
  'Nephew (Brother\'s Son)': 4,
  'Niece (Brother\'s Daughter)': 4,
  'Nephew (Sister\'s Son)': 4,
  'Niece (Sister\'s Daughter)': 4,
  
  // Generation 5 (Grandchildren)
  'Grandson': 5,
  'Granddaughter': 5,
  
  // Generation 6 (Great-grandchildren)
  'Great-Grandson': 6,
  'Great-Granddaughter': 6,
};

// ══════════════════════════════════════════════════════════
// SUPPORT LEVELS
// ══════════════════════════════════════════════════════════

export const SUPPORT_LEVELS = [
  'Strong Support',
  'Leaning Support',
  'Undecided',
  'Leaning Against',
  'Strong Against',
];

export const SUPPORT_COLORS = {
  'Strong Support': { bg: 'var(--sup-strong-bg)', text: 'var(--sup-strong-text)', dot: 'var(--sup-strong-dot)' },
  'Leaning Support': { bg: 'var(--sup-lean-bg)', text: 'var(--sup-lean-text)', dot: 'var(--sup-lean-dot)' },
  'Undecided': { bg: 'var(--sup-undecided-bg)', text: 'var(--sup-undecided-text)', dot: 'var(--sup-undecided-dot)' },
  'Leaning Against': { bg: 'var(--sup-against-lean-bg)', text: 'var(--sup-against-lean-text)', dot: 'var(--sup-against-lean-dot)' },
  'Strong Against': { bg: 'var(--sup-against-bg)', text: 'var(--sup-against-text)', dot: 'var(--sup-against-dot)' },
};

// ══════════════════════════════════════════════════════════
// PARTY STATUS
// ══════════════════════════════════════════════════════════

export const PARTY_OPTIONS = [
  { value: 'MDP',       label: 'MDP' },
  { value: 'PNC',       label: 'PNC' },
  { value: 'AP',        label: 'AP' },
  { value: 'JP',        label: 'JP' },
  { value: 'MDA',       label: 'MDA' },
  { value: 'MLCD',      label: 'MLCD' },
  { value: 'MNP',       label: 'MNP' },
  { value: 'Democrats', label: 'Democrats' },
  { value: 'PNF',       label: 'PNF' },
  { value: 'none',      label: 'No Party' },
];

// ══════════════════════════════════════════════════════════
// ISLANDS & WARDS
// ══════════════════════════════════════════════════════════

export const ISLANDS = ['Fonadhoo', 'Maamendhoo'];

export const WARDS = {
  'Fonadhoo': ['Uthuru', 'Medhu', 'Dhekunu', 'Gaadhoo'],
  'Maamendhoo': ['East', 'West'],
};

// ══════════════════════════════════════════════════════════
// OUTREACH TYPES
// ══════════════════════════════════════════════════════════

// Outreach types, grouped for a scannable picker. Refined from the old flat
// list: tidied verbose names ("In-Person Visit (Home)" → "Home Visit"), merged
// redundant pairs (One-on-One/Group Coffee → "Coffee / Tea Meet"; Met at Event +
// Rally Attendance → "Rally / Event"). super_admin / campaign_manager can add
// more at runtime (stored in app_settings key 'outreach_types').
export const OUTREACH_TYPE_GROUPS = [
  { label: 'In-Person',      types: ['Door-to-Door', 'Home Visit', 'Workplace Visit'] },
  { label: 'Call & Message', types: ['Phone Call', 'WhatsApp', 'SMS', 'Email', 'Social Media DM'] },
  { label: 'Meetings',       types: ['One-on-One Meeting', 'Group Meeting', 'Coffee / Tea Meet', 'Family Introduction'] },
  { label: 'Events & Social', types: ['Rally / Event', 'Mosque / Community', 'Funeral / Condolence', 'Wedding / Celebration'] },
];

// Flat list — kept for filters (EnhancedOutreach, AdvancedSearch) and back-compat.
export const OUTREACH_TYPES = OUTREACH_TYPE_GROUPS.flatMap(g => g.types);

export const OUTREACH_OUTCOMES = [
  'No Answer / Not Home',
  'Busy / Call Back Later',
  'Conversation',
  'Commitment Made',
  'Commitment Withdrawn',
  'Issue Discussed',
  'Literature Left',
  'Refused to Talk',
  'Hostile Response',
];

// ══════════════════════════════════════════════════════════
// EVENT TYPES
// ══════════════════════════════════════════════════════════

export const EVENT_TYPES = [
  'Rally / Public Meeting',
  'Door-to-Door Canvassing',
  'Community Service',
  'House Meeting (Small Group)',
  'One-on-One Meeting',
  'Party Event',
  'Debate',
  'Town Hall',
];

// ══════════════════════════════════════════════════════════
// ISSUES
// ══════════════════════════════════════════════════════════

export const ISSUE_OPTIONS = [
  'Healthcare',
  'Education',
  'Jobs & Employment',
  'Infrastructure',
  'Fisheries',
  'Tourism',
  'Environment',
  'Housing',
  'Youth Programs',
  'Elderly Care',
  'Utilities (Water/Electricity)',
  'Transportation',
  'Public Safety',
  'Corruption',
  'Cost of Living',
  'Financial Difficulties',
];

// ══════════════════════════════════════════════════════════
// DEMOGRAPHICS
// ══════════════════════════════════════════════════════════

export const GENDER_OPTIONS = ['Male', 'Female'];

export const OCCUPATION_CATEGORIES = [
  // Major employers (companies / state-owned enterprises / institutions)
  'BML',
  'Dhiraagu',
  'HDFC',
  'HDC',
  'IAS',
  'MACL',
  'MPL',
  'MTDC',
  'MTCC',
  'MWSC',
  'STO',
  'MIFCO',
  'WAMCO',
  'FENAKA',
  'STELCO',
  'RDC',
  'MNSL',
  'MITDC',
  'BCC',
  'NSPA',
  'MFMC',
  'MPAO',
  'MIB',
  'MSE',
  'Allied Insurance',
  'Ooredoo Maldives',
  'MMPRC',
  'MCIF',
  'MTA',
  'RAC',
  'MHC',
  'MQA',
  // General categories
  'Political',
  'Civil servant',
  'Unemployed',
  'Self employed',
  'Fisherman',
  'Health sector',
  'Tourism sector',
  'Private sector',
  'Business owner',
  'Education sector',
  'Student',
  'Retired',
];

export const LITERACY_LEVELS = [
  'High',
  'Medium',
  'Low',
  'Illiterate',
];

export const INCOME_BRACKETS = [
  'High',
  'Medium-High',
  'Medium',
  'Medium-Low',
  'Low',
];

export const LANGUAGES = [
  'Dhivehi',
  'English',
  'Arabic',
  'Hindi',
  'Other',
];

// ══════════════════════════════════════════════════════════
// GOTV
// ══════════════════════════════════════════════════════════

export const VOTE_COMMITMENT_OPTIONS = [
  'YES',
  'NO',
  'MAYBE',
  'NO_RESPONSE',
];

export const COMMITMENT_TYPES = [
  'Verbal (In-Person)',
  'Verbal (Phone)',
  'Written',
  'Family Commitment',
];

export const COMMITMENT_CONFIDENCE = [
  'High',
  'Medium',
  'Low',
];

// ══════════════════════════════════════════════════════════
// SUPPORT METADATA
// ══════════════════════════════════════════════════════════

export const SUPPORT_STRENGTH = [
  'Committed',
  'Soft',
  'Conditional',
];

export const LIKELIHOOD_TO_VOTE = [
  'Will definitely vote',
  'Might vote',
  'Won\'t vote',
  'Unknown',
];

export const INFLUENCE_LEVEL = [
  'High',
  'Medium',
  'Low',
];

// ══════════════════════════════════════════════════════════
// REMINDER TYPES
// ══════════════════════════════════════════════════════════

export const REMINDER_TYPES = [
  'Call',
  'Visit',
  'WhatsApp',
  'Email',
  'Follow-Up',
];

export const REMINDER_PRIORITY = [
  'Urgent',
  'High',
  'Medium',
  'Low',
];

export const REMINDER_RECURRING = [
  'Once',
  'Daily',
  'Weekly',
  'Monthly',
];

// ══════════════════════════════════════════════════════════
// USER PERMISSIONS
// ══════════════════════════════════════════════════════════

export const PERMISSIONS = {
  super_admin: {
    canViewAll: true, canEditAll: true, canEditInfo: true, canEditVotes: true,
    canEditParty: true, canViewVotes: true, canViewParty: true, canLogOutreach: true,
    canManageUsers: true, canExport: true, canManageCandidates: true, canManageEvents: true,
    canManageTrips: true,
    canViewAnalytics: true, canAssignTerritories: true, canViewFamily: true,
  },
  campaign_manager: {
    canViewAll: true, canEditAll: true, canEditInfo: true, canEditVotes: true,
    canEditParty: true, canViewVotes: true, canViewParty: true, canLogOutreach: true,
    canManageUsers: true, canExport: false, canManageCandidates: true, canManageEvents: true,
    canManageTrips: true,
    canViewAnalytics: true, canAssignTerritories: true, canViewFamily: true,
  },
  candidate: {
    canViewAll: true, canEditAll: true, canEditInfo: true, canEditVotes: true,
    canEditParty: true, canViewVotes: true, canViewParty: true, canLogOutreach: true,
    canManageUsers: true, canExport: false, canManageCandidates: true, canManageEvents: true,
    canManageTrips: true,
    canViewAnalytics: true, canAssignTerritories: true, canViewFamily: true,
  },
  campaign_trips_manager: {
    canViewAll: false, canEditAll: false, canEditInfo: false, canEditVotes: false,
    canEditParty: false, canViewVotes: false, canViewParty: false, canLogOutreach: false,
    canManageUsers: false, canExport: false, canManageCandidates: false, canManageEvents: false,
    canManageTrips: true,
    canViewAnalytics: false, canAssignTerritories: false, canViewFamily: false,
  },
  trip_organizer: {
    canViewAll: false, canEditAll: false, canEditInfo: false, canEditVotes: false,
    canEditParty: false, canViewVotes: false, canViewParty: false, canLogOutreach: false,
    canManageUsers: false, canExport: false, canManageCandidates: false, canManageEvents: false,
    canManageTrips: true,
    canViewAnalytics: false, canAssignTerritories: false, canViewFamily: false,
  },
  atoll_coordinator: {
    canViewAll: false, canEditAll: true, canEditInfo: true, canEditVotes: true,
    canEditParty: true, canViewVotes: true, canViewParty: true, canLogOutreach: true,
    canManageUsers: false, canExport: false, canManageCandidates: false, canManageEvents: true,
    canViewAnalytics: true, canAssignTerritories: true, canViewFamily: true,
  },
  city_manager: {
    canViewAll: false, canEditAll: true, canEditInfo: true, canEditVotes: true,
    canEditParty: true, canViewVotes: true, canViewParty: true, canLogOutreach: true,
    canManageUsers: false, canExport: false, canManageCandidates: false, canManageEvents: true,
    canViewAnalytics: true, canAssignTerritories: true, canViewFamily: true,
  },
  constituency_manager: {
    canViewAll: false, canEditAll: true, canEditInfo: true, canEditVotes: true,
    canEditParty: true, canViewVotes: true, canViewParty: true, canLogOutreach: true,
    canManageUsers: false, canExport: false, canManageCandidates: false, canManageEvents: true,
    canViewAnalytics: true, canAssignTerritories: false, canViewFamily: true,
  },
  island_manager: {
    canViewAll: false, canEditAll: true, canEditInfo: true, canEditVotes: true,
    canEditParty: true, canViewVotes: true, canViewParty: true, canLogOutreach: true,
    canManageUsers: false, canExport: false, canManageCandidates: false, canManageEvents: true,
    canViewAnalytics: true, canAssignTerritories: false, canViewFamily: true,
  },
  outreach_manager: {
    canViewAll: false, canEditAll: false, canEditInfo: true, canEditVotes: false,
    canEditParty: false, canViewVotes: false, canViewParty: false, canLogOutreach: true,
    canManageUsers: false, canExport: false, canManageCandidates: false, canManageEvents: false,
    canViewAnalytics: true, canAssignTerritories: false, canViewFamily: true,
  },
  event_manager: {
    canViewAll: false, canEditAll: false, canEditInfo: false, canEditVotes: false,
    canEditParty: false, canViewVotes: false, canViewParty: false, canLogOutreach: false,
    canManageUsers: false, canExport: false, canManageCandidates: false, canManageEvents: true,
    canViewAnalytics: false, canAssignTerritories: false, canViewFamily: false,
  },
  patch_agent: {
    canViewAll: false, canEditAll: false, canEditInfo: false, canEditVotes: false,
    canEditParty: false, canViewVotes: false, canViewParty: false, canLogOutreach: true,
    canManageUsers: false, canExport: false, canManageCandidates: false, canManageEvents: false,
    canViewAnalytics: false, canAssignTerritories: false, canViewFamily: true,
  },
};

// Helper function to check permissions
export function hasPermission(role, permission) {
  return PERMISSIONS[role]?.[permission] || false;
}

// Checks role-based permissions AND any manually granted temporary permissions.
// profile must be the full profile object (needs temp_permissions + revoked_permissions arrays).
export function hasEffectivePermission(profile, permission) {
  if (!profile) return false;
  if (Array.isArray(profile.revoked_permissions) && profile.revoked_permissions.includes(permission)) return false;
  if (Array.isArray(profile.temp_permissions) && profile.temp_permissions.includes(permission)) return true;
  return hasPermission(profile.role, permission);
}

// Permissions that super_admin / campaign_manager can grant temporarily
export const TEMP_PERMISSION_OPTIONS = [
  { key: 'canLogOutreach',   label: 'Search & Outreach Access' },
  { key: 'canViewAll',       label: 'Full Voter List' },
  { key: 'canViewVotes',     label: 'View Support Data' },
  { key: 'canViewAnalytics', label: 'Analytics' },
  { key: 'canManageEvents',  label: 'Events Management' },
  { key: 'canViewFamily',    label: 'Household Access' },
  { key: 'canEditInfo',      label: 'Edit Voter Info' },
  { key: 'canManageTrips',   label: 'Campaign Trips' },
];

// ══════════════════════════════════════════════════════════
// MESSAGE TEMPLATE VARIABLES
// ══════════════════════════════════════════════════════════

export const TEMPLATE_VARIABLES = [
  '{name}',
  '{island}',
  '{ward}',
  '{polling_station}',
  '{phone}',
  '{date}',
  '{time}',
];

// ══════════════════════════════════════════════════════════
// COLORS & STYLING
// ══════════════════════════════════════════════════════════

export const CANDIDATE_COLORS = [
  '#3b82f6', // Blue
  '#ef4444', // Red
  '#10b981', // Green
  '#f59e0b', // Amber
  '#8b5cf6', // Purple
  '#ec4899', // Pink
  '#14b8a6', // Teal
  '#f97316', // Orange
];

export const CHART_COLORS = {
  primary: '#3b82f6',
  success: '#10b981',
  warning: '#f59e0b',
  danger: '#ef4444',
  info: '#6366f1',
  gray: 'var(--text-3)',
};

// ══════════════════════════════════════════════════════════
// EXPORT ALL
// ══════════════════════════════════════════════════════════

export default {
  FAMILY_ROLES,
  ROLE_GENERATION,
  SUPPORT_LEVELS,
  SUPPORT_COLORS,
  PARTY_OPTIONS,
  ISLANDS,
  WARDS,
  OUTREACH_TYPES,
  OUTREACH_OUTCOMES,
  EVENT_TYPES,
  ISSUE_OPTIONS,
  GENDER_OPTIONS,
  OCCUPATION_CATEGORIES,
  LITERACY_LEVELS,
  INCOME_BRACKETS,
  LANGUAGES,
  VOTE_COMMITMENT_OPTIONS,
  COMMITMENT_TYPES,
  COMMITMENT_CONFIDENCE,
  SUPPORT_STRENGTH,
  LIKELIHOOD_TO_VOTE,
  INFLUENCE_LEVEL,
  REMINDER_TYPES,
  REMINDER_PRIORITY,
  REMINDER_RECURRING,
  PERMISSIONS,
  hasPermission,
  TEMPLATE_VARIABLES,
  CANDIDATE_COLORS,
  CHART_COLORS,
};
